<script>
  // navigatie
  import Tabs from "./Tabs.svelte";

  let tabItems = [
    { label: "Opgaven", value: 1 },
    { label: "Antwoorden", value: 2 }
  ];

  let currentTab = 2;

  // app
  import Opgave from "./Opgave.svelte";
  import Antwoorden from "./Antwoorden.svelte";

  // data
  import { kerst } from './stores/2024.store.js';
</script>

<h1>Dr Denker kerstpuzzel 2024</h1>

<Tabs bind:activeTabValue={currentTab} items={tabItems} />

{#if 1 === currentTab}
  <div class="flexylexy">
    {#each $kerst as opgave (opgave.id)}
      <Opgave id={opgave.id} />
    {/each}
  </div>
{/if}

{#if 2 === currentTab}
  <Antwoorden />
{/if}

<style>
  h1 {
    color: #ff3e00;
    font-size: 4em;
    font-weight: 100;
    text-align: center;
  }
  .flexylexy {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 3em;
  }
</style>